import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import Notice from "../entities/notice";

interface NoticeState {
    unreadCount: number;
    totalCount: number;
    pageSize: number;
    list: Array<Notice>;
    loading: boolean;
    state: number;
    skipCount: number;
    loadMore: boolean;
}

class NoticeModule {
    namespaced = true;
    state = {
        unreadCount: 0,
        totalCount: 0,
        pageSize: 10,
        list: new Array<Notice>(),
        loading: false,
        state: 0,
        skipCount: 0,
        loadMore: false
    };
    mutations = {
        setPageSize(state:NoticeState,pagesize:number){
            state.pageSize=pagesize;
        },
        setLoadMore(state:NoticeState,loadMore:boolean) {
            state.loadMore = loadMore;
        }
    };
    actions = {
        async getAll(context:ActionContext<NoticeState,any>,payload:any){
            context.state.loading=true;
            let pageRequest = {
                state: context.state.state,
                maxResultCount: context.state.pageSize,
                skipCount: context.state.skipCount
            };
            if (context.state.loadMore == true) {
                pageRequest.skipCount = context.state.list.length;
            }
            let reponse=await Ajax.get('/api/services/app/Notification/GetUserNotifications',{params:pageRequest});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Notice>;
            context.state.totalCount=page.totalCount;
            context.state.unreadCount = reponse.data.result.unreadCount;
            if(context.state.loadMore == false) {
                context.state.list=page.items;
            } else {
                context.state.list = context.state.list.concat(page.items);
            }
        }
    };
}

const noticeModule = new NoticeModule();
export default noticeModule;